import { useMediaQuery, useTheme } from '@mui/material';

import type { HeroProps } from './Hero.types';
import {
  StyledLink,
  BorderStack,
  MenuCircles,
  StyledStack,
  StyledButton,
  ContentWrapper,
  HeadingWrapper,
  StyledMacWindow,
  StyledBackground,
  StyledHeaderLogo,
  StyledHeroHeading,
  StyledHeroSection,
  StyledUnderHeading,
  StyledButtonWrapper,
  StyledKeepScrolling,
  StyledHeroDescription,
  StyledScheduleCallArea,
} from './styles';

export const Hero = ({ ...props }: HeroProps) => {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints?.down('sm'));

  return (
    <>
      <StyledHeroSection width="normal">
        <StyledStack>
          <StyledBackground />
          <StyledMacWindow ref={props.bannerRef}>
            <BorderStack>
              <MenuCircles>
                <div />
                <div />
                <div />
              </MenuCircles>
            </BorderStack>

            <ContentWrapper>
              <HeadingWrapper>
                <StyledHeroHeading variant="display_md">
                  Extensive
                  <StyledHeaderLogo />
                </StyledHeroHeading>
                <StyledUnderHeading variant="regular_600">
                  IT services for <b>your</b> startup
                </StyledUnderHeading>
              </HeadingWrapper>

              {mobile ? (
                <StyledHeroDescription variant="regular_500">
                  Turn your product idea into a thriving business!
                </StyledHeroDescription>
              ) : (
                <StyledHeroDescription variant="regular_500">
                  Want to turn your product idea into a thriving business?
                  <br />
                  Get your startup off the ground with our team of software
                  development experts!
                </StyledHeroDescription>
              )}

              <StyledScheduleCallArea>
                <StyledHeroDescription variant="regular_400" align="center">
                  Why wait?
                </StyledHeroDescription>
                <StyledButtonWrapper>
                  <StyledLink to="/contact">
                    <StyledButton>Schedule a call today!</StyledButton>
                  </StyledLink>
                </StyledButtonWrapper>
                <StyledKeepScrolling />
              </StyledScheduleCallArea>
            </ContentWrapper>
          </StyledMacWindow>
        </StyledStack>
      </StyledHeroSection>
    </>
  );
};
